import { shouldRenderMobile } from '@philips-emr/hpms-health-insurance-components';
import { AvatarAPI, ImageAPI, SocialNetworksAPI } from '@philips-emr/tws-components';
import { DismissStyle, ThemeTonalRange, ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { MessageService, ModalService, ToastService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames } from '../codegen';
import { Configuration } from '../services/configuration';

@Controller({ fragment: FragmentNames.FOOTER })
export default class FooterController {

  @OnMount('social-networks')
  onSocialNetworksMount(event: MountEvent): void {
    const api = event.target as SocialNetworksAPI;

    void Configuration.getData().then((data :any) => {
      data.dsLinkFacebook && api.setFacebook(data.dsLinkFacebook);
      data.dsLinkInstagram && api.setInstagram(data.dsLinkInstagram);
      data.dsLinkLinkedin && api.setLinkedin(data.dsLinkLinkedin);
      data.dsLinkTwitter && api.setTwitter(data.dsLinkTwitter);
      data.dsLinkYoutube && api.setYoutube(data.dsLinkYoutube);
    });
  }

  @OnMount('image-footer')
  onImageFooterMount(event: MountEvent): void {
    const api = event.target as ImageAPI;
    void Configuration.getData().then((data :any) => data.dsUrlLogoFooter && api.setSrc(data.dsUrlLogoFooter));
  }

  @OnMount('avatar-endereco')
  onAvatarEnderecoMount(event: MountEvent): void {
    const api = event.target as AvatarAPI;
    void Configuration.getData().then((data :any) => data.dsEndereco && api.setTitle(data.dsEndereco));
  }

  @OnMount('avatar-contato')
  onAvatarContatoMount(event: MountEvent): void {
    const api = event.target as AvatarAPI;
    void Configuration.getData().then((data :any) => {
      const { nrFoneContato = '', dsEmailRodape = '' } = data;

      if (shouldRenderMobile()) {
        api.setTitle(`${MessageService.msg('med.telefone')}: ${nrFoneContato}`);
        api.setSubtitle(`${MessageService.msg('med.email')}: ${dsEmailRodape}`);
      } else {
        api.setTitle(`${MessageService.msg('med.telefone')}: ${nrFoneContato} | ${MessageService.msg('med.email')}: ${dsEmailRodape}`);
      }
    });
  }

  @OnMount('link-cookies')
  onLinkCookiesMount(): void {
    ToastService.open({
      id: 'c-toast-notification__message--cookies',
      title: 'med.politica-cookies',
      message: 'med.cookie',
      dismissible: true,
      dismissStyle: DismissStyle.BUTTON,
      showIcon: true,
      dismissExpression: 'OK',
      // action: (<Link onClick={() => this.onLinkCookiesClick()} value={'med.politica-cookies'} />),
      level: ToastLevel.WARNING,
      highlight: true,
    });
  }

  @OnClick('link-cookies')
  onLinkCookiesClick(): void {
    ModalService.openDefault({
      closeable: true,
      fragment: 'cookie',
      title: 'med.politica-cookies',
    });
  }

  @OnClick('link-version')
  onLinkVersionClick(): void {
    ModalService.openDefault({
      theme: ThemeTonalRange.BRIGHT,
      closeable: true,
      // children: (<Copyright applicationName={'med.guia-medico'} />),
    });
  }
}
